export default {"src":"/_next/static/media/icon-biport.c09ae743.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};